import React, { useState, useEffect, Fragment } from 'react'
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Select from "react-select";
import { Select as SearchBox } from 'antd';
import ReactLoading from "react-loading";
import {
    antdesignSelectStyle,
    formatDateNoTime,
    getTodayDate,
    getTodayDateISO,
    getTodayDateNoTime,
    numberFormat,
    refreshPage,
    toastStyle,
    TokenExpiry,
} from "../../../Helpers/Utils/Common";
import Navbar from "../../../Components/Navbar/Navbar";
import InputError from "../../../Components/InputError/InputError";
//api
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { validateDiscount } from './../../../Helpers/Validation/Manage/DiscountsValidation';
import { searchBranch } from './../../../Helpers/apiCalls/Manage/Branches';
import { searchBranchPotato } from './../../../Helpers/apiCalls/PotatoCorner/Manage/Branches';
import { createDiscounts, updateDiscounts, getDiscounts } from './../../../Helpers/apiCalls/Manage/DiscountsApi';
import { searchItem } from '../../../Helpers/apiCalls/itemsApi';
import { getCategory } from '../../../Helpers/apiCalls/categoryApi';
import Footer from '../../../Components/Footer/Footer';

function FormDiscounts({ add, edit }) {
    //variables
    const { type, id } = useParams()
    let navigate = useNavigate();
    const [inactive, setInactive] = useState(true);
    const [isSubmitClicked, setIsSubmitClicked] = useState(false);
    const [isSaveClicked, setIsSaveClicked] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [branches, setBranches] = useState([]);
    const [items, setItems] = useState([]);
    const [category, setCategory] = useState([]);
    const today = getTodayDateISO();
    const [addDetails, setAddDetails] = useState({
        description: "",
        remarks: "",
        type: "",
        valid_from: "",
        valid_to: "",
        discount_source: "",
        commission_base: "",
        commission_rate: 0,
        vat_rate: 0,
        other_fee: 0,
        discount_amount: 0,
        mm_discount_share: 0,
        delivery_discount_share: 0,
    });
    const [isError, setIsError] = useState({
        days: false,
        discount_source: false,
        commission_base: false,
        branches: false,
        valid_from: false,
        valid_to: false,
        description: false,
    });
    const days = [
        { value: "sunday", label: "Sunday" },
        { value: "monday", label: "Monday" },
        { value: "tuesday", label: "Tuesday" },
        { value: "wednesday", label: "Wednesday" },
        { value: "thursday", label: "Thursday" },
        { value: "friday", label: "Friday" },
        { value: "saturday", label: "Saturday" },
      ];
      const [selected, setSelected] = useState([]);
      const [selectedBranches, setSelectedBranches] = useState([]);
      const [selectedItems, setSelectedItems] = useState([]);
      const [selectedCategories, setSelectedCategories] = useState([]);

    //functions
    const handleAddChange = (e, type) => {
        
        if(type === "select") {
            setAddDetails((prevState) => ({
                ...prevState,
                [e.for]: e.value,
                [e.select_value]: {
                    for: e.for,
                    label: e.label,
                    value: e.value,
                }
            }));
        } else {
            const { name, value } = e.target;
            
            setAddDetails((prevState) => ({
            ...prevState,
            [name]: value,
            }));
        }
    }
    
    
    

    const handleSubmit = () => {
        if (add) handleCreateDiscount();
        else if (edit) handleUpdateDiscount();
    };

    //API
    async function fetchEmployees() {

        const response = await getAllEmployees();
        if (response.error) {
            setEmployees([])
        } else {
            let result = response.data.data.map((data) => {
                var employee = data;
                employee.for = "employee_id"
                employee.select_value = "employee_id_value"
                employee.label = data.first_name + " " + data.last_name;
                employee.value = data.id;
                return employee;
            });
            setEmployees(result);
        }
    }

    async function fetchBranches() {
        setBranches([]);
        const response = await searchBranch({is_franchise: 0});
        if (response.data) {
            var result = response.data.data.map((data) => {
                var branch = data;
                branch.label = data.name;
                branch.value = data.id;
                return branch;
            });
            setBranches(result);
        } else if (response.error) {
            TokenExpiry(response);
        }
    }

    async function fetchItems() {
        setItems([]);
        const response = await searchItem({});
        if (response.response) {
            var result = response.response.data.map((data) => {
                var branch = data;
                branch.label = data.name;
                branch.value = data.id;
                return branch;
            });
            setItems(result);
        } else if (response.error) {
            TokenExpiry(response);
        }
    }

    async function fetchCategories() {
        setCategory([]);
        const response = await getCategory({});
        if (response.data) {
        //categories
        var categories = response.data.data.map((category) => {
            var info = category
            info.value = category.name
            info.label = category.name
            return info
        })
        setCategory(categories);
        }
    }
    
    async function handleCreateDiscount() {
        if (isSubmitClicked) {
            return;
        }
        if (validateDiscount(addDetails, selected, selectedBranches, selectedItems, selectedCategories, setIsError)) {
            setIsSubmitClicked(true);
            const response = await createDiscounts(addDetails, selected, selectedBranches, selectedItems, selectedCategories);
            
            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    navigate(-1)
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    setIsSubmitClicked(false);
                    // navigate(-1)
                }, 1000);
            }
        } else {
            toast.error("Please fill in all fields", {
                style: toastStyle(),
            });
        }
    }

    async function handleUpdateDiscount() {
        if (isSubmitClicked) {
            return;
        }
        if (validateDiscount(addDetails, selected, selectedBranches, selectedItems, selectedCategories, setIsError)) {
            setIsSubmitClicked(true);
            const response = await updateDiscounts(addDetails, selected, selectedBranches, selectedItems, selectedCategories);
            
            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    navigate(-1)
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    setIsSubmitClicked(false);
                    // navigate(-1)
                }, 1000);
            }
        } else {
            toast.error("Please fill in all fields", {
                style: toastStyle(),
            });
        }
    }

    async function fetchData() {
        setAddDetails([]);

        const response = await getDiscounts(id);
        

        if (response.error) {
            // TokenExpiry(response);
        } else {
            var expense = response.data.data.map((data) => {
                var info = data;
                info.discount_source = data.discount_source ? data.discount_source : data.merchant
                return info;
            });
            setAddDetails(expense[0])
            var days = []
            if(expense[0].sundays === "1") {
                days.push({value: "sunday", label: "Sunday"})
            }
            if(expense[0].mondays === "1") {
                days.push({value: "monday", label: "Monday"})
            }
            if(expense[0].tuesdays === "1") {
                days.push({value: "tuesday", label: "Tuesday"})
            }
            if(expense[0].wednesdays === "1") {
                days.push({value: "wednesday", label: "Wednesday"})
            }
            if(expense[0].thursdays === "1") {
                days.push({value: "thursday", label: "Thursday"})
            }
            if(expense[0].fridays === "1") {
                days.push({value: "friday", label: "Friday"})
            }
            if(expense[0].saturdays === "1") {
                days.push({value: "saturday", label: "Saturday"})
            }
            
            setSelected(days)

            var branch = []
            if(expense[0].discount_branches.length > 0) {
                expense[0].discount_branches.map((data) => {
                    branch.push({
                        id: data.branch_id,
                        value: data.branch_id,
                        label: data.branch_name,
                    })
                })
            }
            setSelectedBranches(branch)
        }
        
    }

    const handleSearchItem = (newValue) => {
        if(newValue.length > 2) { //if length of the input is greater than 3, it will call the search api
        handleFetchItems(newValue, setItems);
        }
    };

    // new api for searching items
    async function handleFetchItems(value, setItems) {
        setItems([]);
        const response = await searchItem({name: value});
        if (response.response) {
        var itemsList = response.response.data.map((data) => {
            var info = data
            info.label = data.name
            info.value = data.id
            return info;
        });
        setItems(itemsList);
        } else {
        response.error?.data?.messages?.map((data) => {
            return toast.error(data, {
            style: toastStyle(),
            });
        })
        }
    }
    console.log(items)

    useEffect(() => {
        fetchEmployees();
        fetchBranches();
        fetchItems();
        fetchCategories();
        if(edit) {
            fetchData()
        }
    }, []);
    console.log(selectedItems)
    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"MANAGE"}
                />
            </div>

            <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
                {/* header */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> {add ? "ADD " : "EDIT "} DISCOUNT </h1>
                    </Col>
                </Row>

                {/* content */}
                <div className="edit-form">
                    {/* FRANCHISEE SALES INVOICE DETAILS */}
                    <Fragment>
                        {
                            type === "item" ? (
                                <>
                                <Row className="mt-2 mb-2">
                                    <Col>
                                    <span className="edit-label">
                                            Applicable Items
                                        </span>
                                        <SearchBox
                                            showSearch
                                            mode="multiple"
                                            value={selectedItems}
                                            placeholder={"Search Items..."}
                                            className="react-select-container w-100"
                                            dropdownClassName="z-large antdesign-custom-dropdown"
                                            style={antdesignSelectStyle}
                                            defaultActiveFirstOption={false}
                                            suffixIcon={null}
                                            filterOption={false}
                                            onSearch={handleSearchItem}
                                            onChange={setSelectedItems}
                                            // onChange={(e) => handleSelectChange(e, "supplier_id")}
                                            notFoundContent={null}
                                            options={(items || []).map((d) => ({
                                                value: d.value,
                                                label: d.label,
                                            }))}
                                        />
                                        {/* <Select
                                            name="applicable_items"
                                            className="nc-modal-custom-text"
                                            options={items}
                                            value={selectedItems}
                                            onChange={setSelectedItems}
                                            placeholder={`Select Items`}
                                            isMulti={true}
                                            isSearchable={true}
                                        /> */}
                                        <InputError
                                            isValid={isError.discount_items}
                                            message={`${type} is required`}
                                        />
                                    </Col>
                                </Row>
                                </>
                            ) : (
                                <>
                                <Row className="mt-2 mb-2">
                                    <Col>
                                    <span className="edit-label">
                                            Applicable Categories
                                        </span>
                                        <Select
                                            name="applicable_category"
                                            className="nc-modal-custom-text"
                                            options={category}
                                            value={selectedCategories}
                                            onChange={setSelectedCategories}
                                            placeholder={`Select Categories`}
                                            isMulti={true}
                                            isSearchable={true}
                                        />
                                        <InputError
                                            isValid={isError.discount_items}
                                            message={`${type} is required`}
                                        />
                                    </Col>
                                </Row>
                                </>
                            )
                        }
                        {/* <Row className="mt-4 mb-2">
                            <Col>
                                <span className="edit-label">
                                    Description
                                    <label className="badge-required">{` *`}</label>
                                </span>
                            </Col>
                        </Row>
                        <Row className="mt-4 mb-2">
                            <Col>
                                <Form.Control
                                    type="text"
                                    name="description"
                                    className="nc-modal-custom-text"
                                    value={addDetails.description}
                                    onChange={(e) => handleAddChange(e)} 
                                />
                                <InputError
                                    isValid={isError.description}
                                    message={"Description is required"}
                                />
                            </Col>
                        </Row> */}
                        <Row className="mb-2">
                            <Col xs={12} lg={3}>
                                <span className="edit-label">
                                    Valid Date From
                                    <label className="badge-required">{` *`}</label>
                                </span>
                                <Form.Control
                                    type="date"
                                    name="valid_from"
                                    className="nc-modal-custom-text"
                                    value={addDetails.valid_from}
                                    onChange={(e) => handleAddChange(e, false)}
                                />
                                <InputError
                                    isValid={isError.valid_from}
                                    message={"Valid from is required"}
                                />
                            </Col>
                            <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                                <span className="edit-label">
                                    Valid Date To
                                    <label className="badge-required">{` *`}</label>
                                </span>
                                <Form.Control
                                    type="date"
                                    name="valid_to"
                                    className="nc-modal-custom-text"
                                    value={addDetails.valid_to}
                                    onChange={(e) => handleAddChange(e, false)}
                                />
                                <InputError
                                    isValid={isError.valid_to}
                                    message={"Valid to is required"}
                                />
                            </Col>
                            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                                <span className="edit-label">
                                    Applicable Days
                                </span>
                                <Select
                                    name="applicable_days"
                                    className="nc-modal-custom-text"
                                    options={days}
                                    value = {selected}
                                    onChange={setSelected}
                                    placeholder={`Select Days`}
                                    isMulti={true}
                                    isSearchable={true}
                                />
                                <InputError
                                    isValid={isError.days}
                                    message={"Days is required"}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={12} lg={4}>
                            <span className="edit-label">
                                    customer discount
                                </span>
                                <Form.Control
                                    type="text"
                                    name="discount_amount"
                                    className="nc-modal-custom-text"
                                    value={addDetails.discount_amount}
                                    onChange={(e) => handleAddChange(e)} 
                                />
                                {/* <InputError
                                    isValid={isError.discount_amount}
                                    message={"discount_amount is required"}
                                /> */}
                            </Col>
                            <Col xs={6} lg={4}>
                                <Form.Group
                                    className=""
                                    controlId="formBasicCheckbox"
                                >
                                    <Form.Check
                                        type="radio"
                                        label="Amount Per Unit"
                                        name="type"
                                        value="fixed"
                                        className="pt-2"
                                        checked={addDetails.type === "fixed"}
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={6} lg={4}>
                                <Form.Group
                                    className=""
                                    controlId="formBasicCheckbox"
                                >
                                    <Form.Check
                                        type="radio"
                                        label="Percentage Per Unit"
                                        name="type"
                                        value="percentage"
                                        className="pt-2"
                                        checked={addDetails.type === "percentage"}
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        {/* <Row className="mt-4">
                            <Col xs={4}>
                                <span className="edit-label">
                                    MM DISCOUNT SHARE
                                </span>
                            </Col>
                            <Col xs={4}>
                                <span className="edit-label">
                                    DELIVERY COMPANY
                                </span>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={4}>
                                <Form.Control
                                    type="text"
                                    name="mm_discount_share"
                                    className="nc-modal-custom-text"
                                    value={addDetails.mm_discount_share}
                                    onChange={(e) => handleAddChange(e)} 
                                />
                            </Col>
                            <Col xs={4}>
                                <Form.Control
                                    type="text"
                                    name="delivery_discount_share"
                                    className="nc-modal-custom-text"
                                    value={addDetails.delivery_discount_share}
                                    onChange={(e) => handleAddChange(e)} 
                                />
                            </Col>
                        </Row>
                        <Row className="mt-4 mb-2">
                            <Col>
                                <span className="edit-label">
                                    Remarks
                                </span>
                            </Col>
                        </Row>
                        <Row className="mt-4 mb-2">
                            <Col>
                                <Form.Control
                                    type="text"
                                    name="remarks"
                                    className="nc-modal-custom-text"
                                    value={addDetails.remarks}
                                    onChange={(e) => handleAddChange(e)} 
                                />
                            </Col>
                        </Row> */}
                        <Row className="mt-4 mb-2">
                            <Col>
                                <span className="edit-label">
                                    Applicable Branches
                                </span>
                            </Col>
                        </Row>
                        <Row className="mt-2 mb-2">
                            <Col>
                                <Select
                                    name="applicable_branches"
                                    className="nc-modal-custom-text"
                                    options={branches}
                                    value={selectedBranches}
                                    onChange={setSelectedBranches}
                                    placeholder={`Select Branches`}
                                    isMulti={true}
                                    isSearchable={true}
                                />
                                 <InputError
                                    isValid={isError.branches}
                                    message={"branches is required"}
                                />
                            </Col>
                        </Row>
                        
                    </Fragment>

                    {/* FOOTER: CANCEL & SUBMIT BUTTONS */}
                    <div className="d-flex justify-content-end pt-5 pb-3">
                        <button
                            type="button"
                            className="button-secondary me-3"
                            onClick={() => navigate(-1)}
                        >
                            Cancel
                        </button>
                        {/* {isSaveClicked ? (
                            <div className="button-secondary d-flex justify-content-center">
                                <ReactLoading
                                    type="bubbles"
                                    color="#FFFFFF"
                                    height={50}
                                    width={50}
                                />
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="button-primary me-3"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        )} */}
                        {isSubmitClicked ? (
                            <div className="button-primary d-flex justify-content-center">
                                <ReactLoading
                                    type="bubbles"
                                    color="#FFFFFF"
                                    height={50}
                                    width={50}
                                />
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="button-primary"
                                onClick={handleSubmit}
                            >
                                Save
                            </button>
                        )}
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default FormDiscounts